import { Link } from 'react-router-dom'
import { MessageSquare, Info } from 'lucide-react'

const FEEDBACK_FORM_URL = 'https://forms.gle/TYKX93VYtNXxkV6XA'

export default function Header() {
  return (
    <header className="border-b border-surface-800/50">
      <div className="max-w-5xl mx-auto px-4 py-2 flex items-center justify-end gap-6">
        <Link 
          to="/about" 
          className="inline-flex items-center gap-1.5 text-surface-400 hover:text-surface-200 text-sm transition-colors"
        >
          <Info size={14} />
          About
        </Link>
        <a
          href={FEEDBACK_FORM_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 text-surface-400 hover:text-surface-200 text-sm transition-colors"
        >
          <MessageSquare size={14} />
          Feedback
        </a>
      </div>
    </header>
  )
}

